__webpack_require__.p = "/collaborative_paintapp/";